import { IZipCodeRangeChecker } from '@shared/rangeChecker/IZipCodeRangeChecker';

export class StringZipCodeCodeRangeChecker implements IZipCodeRangeChecker {
	from: string;
	to: string;
	public constructor(from: string, to: string) {
		this.from = from;
		this.to = to;
	}

	public IsValidRange() {
		return this.from !== null && this.to !== null && this.from.localeCompare(this.to, 'en') <= 0;
	}

	public doesRangeOverlap(from: string, to: string): boolean {
		const fromCheck = this.from.localeCompare(from, 'en') <= 0 && this.to.localeCompare(from, 'en') >= 0;
		const toCheck = this.from.localeCompare(to, 'en') <= 0 && this.to.localeCompare(to, 'en') >= 0;
		return fromCheck || toCheck;
	}
}
